import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

// Components
import { SelectInput } from 'components/forms/form-elements';


function TeamSelect({ teams, ...props }) {
  return (
    <SelectInput
      {..._.omit(props, 'dispatch')}
      isLoading={!teams}
      options={teams}
      valueKey="id"
      labelKey="name"
      matchProp="name"
    />
  );
}

TeamSelect.propTypes = {
  teams: PropTypes.array
};

export default connect((state) => ({ teams: state.pageData.teams }))(TeamSelect);



// WEBPACK FOOTER //
// ./app/components/forms/selects/team-select.js